import { fetchJSON } from '../util/fetch_json'
import { noop } from '../util/noop'

interface IHeartbeatData {
  expires_at: string
}
interface IJsonApiHeartbeat {
  data: {
    attributes: IHeartbeatData
  }
}
interface IOptions {
  debug?: boolean
  interval?: number
  onBeat?: (data: IHeartbeatData) => void
}

class Heartbeat {
  private options: Readonly<IOptions>

  constructor({
    debug = false,
    interval = 60, // seconds
    onBeat = noop,
  }: IOptions) {
    this.options = Object.freeze({
      debug,
      interval,
      onBeat,
    })

    window.setInterval(this.beat.bind(this), this.options.interval * 1000)
    this.beat()
  }

  private beat() {
    this.log('beat')

    fetchJSON('/api/v1/heartbeat/new', 'GET')
      .then((data: IJsonApiHeartbeat) => {
        this.options.onBeat(data.data.attributes)
      })
      .catch((error: Error) => {
        window.console.error(error)
        window.location.reload()
      })
  }

  private log(message: string) {
    if (!this.options.debug) {
      return
    }

    window.console.debug(`Heartbeat: ${message}`)
  }
}

export { Heartbeat, IHeartbeatData }
